import { useState, useEffect } from 'react';
import { generateFAQSchema } from '../../../utils/seo';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  useEffect(() => {
    // Add FAQ Schema
    const scriptId = 'schema-faq';
    let script = document.getElementById(scriptId) as HTMLScriptElement;
    
    if (!script) {
      script = document.createElement('script');
      script.id = scriptId;
      script.type = 'application/ld+json';
      document.head.appendChild(script);
    }
    
    script.textContent = JSON.stringify(generateFAQSchema());

    return () => {
      const scriptElement = document.getElementById(scriptId);
      if (scriptElement) {
        scriptElement.remove();
      }
    };
  }, []);

  const faqs = [
    {
      question: '企画がまだ漠然としていますが、相談可能ですか？',
      answer: 'はい。ターゲット層に響くキーワード選定や、ツアーの切り口から一緒に考えさせていただきます。',
    },
    {
      question: '地方の小規模な旅行会社でも対応いただけますか？',
      answer: 'もちろんです。規模の大小にかかわらず、特定のファン層へ向けた「質の高いツアー」の実現をサポートいたします。',
    },
    {
      question: '費用の目安はどのくらいですか？',
      answer: '菊田の同行有無や、撮影・動画編集のボリュームにより異なります。ご予算に合わせて柔軟にプランニング可能です。',
    },
    {
      question: '万が一、ツアーが中止になった場合の対応は？',
      answer: '事前に取り交わす契約に基づき、広報稼働分のみを清算するなど、リスクを最小限に抑えた設計をいたします。',
    },
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-16 sm:py-24 lg:py-32 px-4 sm:px-6 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12 sm:mb-16">
          <div className="inline-block mb-4 sm:mb-6">
            <span className="border-2 border-[#1e3a8a] text-[#1e3a8a] text-xs font-semibold px-4 sm:px-6 py-2 rounded-full uppercase tracking-wider whitespace-nowrap">
              FAQ
            </span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1e3a8a] mb-4 sm:mb-6 leading-tight px-4">
            よくある質問
          </h2>
          <p className="text-base sm:text-lg text-gray-700 leading-relaxed px-4">
            お客様からよくいただくご質問をまとめました。
          </p>
        </div>

        <div className="space-y-4 sm:space-y-6">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden transition-all duration-300 hover:shadow-xl"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 sm:px-8 py-5 sm:py-6 flex items-start sm:items-center justify-between gap-4 text-left cursor-pointer hover:bg-gray-50 transition-colors duration-200"
              >
                <div className="flex items-start gap-3 sm:gap-4 flex-1">
                  <div className="flex-shrink-0 w-8 h-8 sm:w-10 sm:h-10 bg-[#1e3a8a] rounded-lg flex items-center justify-center">
                    <span className="text-white text-sm sm:text-base font-bold">Q</span>
                  </div>
                  <h3 className="text-base sm:text-lg font-bold text-[#1e3a8a] leading-relaxed pt-1">
                    {faq.question}
                  </h3>
                </div>
                <div className="flex-shrink-0 w-6 h-6 sm:w-8 sm:h-8 flex items-center justify-center">
                  <i
                    className={`ri-arrow-down-s-line text-xl sm:text-2xl text-[#1e3a8a] transition-transform duration-300 ${
                      openIndex === index ? 'rotate-180' : ''
                    }`}
                  ></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-6 sm:px-8 pb-5 sm:pb-6">
                  <div className="flex items-start gap-3 sm:gap-4 bg-gradient-to-br from-[#d4af37]/5 to-white p-4 sm:p-6 rounded-xl border-l-4 border-[#d4af37]">
                    <div className="flex-shrink-0 w-8 h-8 sm:w-10 sm:h-10 bg-[#d4af37] rounded-lg flex items-center justify-center">
                      <span className="text-white text-sm sm:text-base font-bold">A</span>
                    </div>
                    <p className="text-sm sm:text-base text-gray-700 leading-relaxed pt-1">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 sm:mt-16 text-center">
          <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6">
            その他のご質問やご不明点がございましたら、お気軽にお問い合わせください。
          </p>
          <a
            href="#contact"
            className="inline-block bg-gradient-to-r from-[#1e3a8a] to-[#3b82f6] text-white px-8 sm:px-10 py-3 sm:py-4 rounded-full text-base sm:text-lg font-bold hover:shadow-2xl hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            お問い合わせはこちら
          </a>
        </div>
      </div>
    </section>
  );
}